<div hidden>
  <ng-template #loading>
    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
  </ng-template>
</div>
<div id='tabExpenses' class='table-bordered'>
  <div *ngIf='!loading; else loading'></div>
</div>
